import { useSearchParams } from 'react-router-dom';

import { DialogKey } from 'components/navigation/WithDialogs';

export const useDialogParam = (dialogKey: DialogKey) => {
  const [searchParams] = useSearchParams();
  return searchParams.get(dialogKey);
};
